import moment from 'moment-timezone';
import 'moment/locale/ja';

export const TOKYO_TZ = 'Asia/Tokyo';

/**
 * Format a reservation datetime for display.
 * Used for ビデオ診療 予定日 — renders the API value as-is without timezone conversion.
 */
export function formatReservationInTokyo(
  value: string | null | undefined,
  format: string,
): string {
  if (!value) {
    return '';
  }

  return moment(value).locale('ja').format(format);
}

/**
 * Split API reservation_date into date/time form fields (JST).
 */
export function reservationDateToFormParts(
  reservationDate: string,
  formatDate: string,
  formatTime: string,
): { date: string; time: string } {
  const m = moment(reservationDate).tz(TOKYO_TZ);

  return {
    date: m.format(formatDate),
    time: m.format(formatTime),
  };
}

/**
 * Build reservation_date payload from modal date + time (interpreted as JST).
 */
export function buildReservationDatePayload(date: string, time: string): string {
  return moment.tz(`${date} ${time}:00`, TOKYO_TZ).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * Add minutes to reservation_date (for calendar end time, video slot length).
 * Renders the API value as-is without timezone conversion.
 */
export function addReservationMinutesInTokyo(
  value: string | null | undefined,
  minutes: number,
  format: string,
): string {
  if (!value) {
    return '';
  }

  return moment(value).locale('ja').add(minutes, 'minutes').format(format);
}
